// The translator module, not the /i18n index: /i18n re-exports /dates.
import { t } from '../i18n/t';
import { formatDate, formatTime } from './format';
import { istanbulMidnight } from './istanbul-day';

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

// "az önce" (also for a time ahead of `now`), "5 dk önce", "3 sa önce" within the Istanbul day,
// "dün 14:30" on the Istanbul day before, then the date. The patterns are the catalog's, not
// Intl.RelativeTimeFormat's ("5 dk. önce").
export function formatRelative(value: string | Date, now: Date | number = Date.now()): string {
  const valueMs = new Date(value).getTime();
  const nowMs = new Date(now).getTime();
  const ago = nowMs - valueMs;
  if (ago < MINUTE_MS) return t('dates.relative.now');
  if (ago < HOUR_MS) return t('dates.relative.minutesAgo', { n: Math.floor(ago / MINUTE_MS) });
  const today = istanbulMidnight(nowMs);
  if (valueMs >= today) return t('dates.relative.hoursAgo', { n: Math.floor(ago / HOUR_MS) });
  if (valueMs >= istanbulMidnight(today - 1)) {
    return t('dates.relative.yesterday', { time: formatTime(value) });
  }
  return formatDate(value);
}
